import React from 'react';
import {get} from 'lodash';
import axios from 'axios';
import moment from 'moment';

import {
  metaLoading,
} from '../lib/helpers';

import UserWithImage from './UserWithImage';
import Loading from './Loading';
import LoadMore from './LoadMore';
import ImageLoader from './ImageLoader';
import PostsListItemVideo from './PostsListItemVideo';

class MessageList extends React.Component {
  static defaultProps = {
    messageTypes: {
      'image': 'Sent image',
      'gif': 'Sent gif',
      'sticker': 'Sent sticker',
      'call': 'Made individual call',
      'match': '',
    }
  }

  state = {
    ...metaLoading,
    messages: [],
  };

  getMessages = () => {
    axios.get(`/${gon.currentProvider}/api/messages`, {
      params: {
        chat_id: get(this.props, 'chat.id'),
        per: get(this.state, 'meta.per'),
        page: get(this.state, 'meta.page'),
      }
    })
    .then((res) => {
      this.setState((prevState) => ({
        meta: {
          ...prevState.meta,
          isLoading: false,
        },
      }), () => {
        const data = get(res, 'data.messages')
        if (res.status == 200 && get(res, 'data')) {
          this.setState((prevState) => ({
            messages: [
              ...prevState.messages,
              ...data,
            ],
            meta: {
              ...prevState.meta,
              isFullyLoaded: get(data, 'length', 0) == 0 ? true : false,
              page: get(prevState, 'meta.page') + 1,
            },
          }))
        }
      })
    })
  }

  componentDidMount() {
    this._load()
  }

  componentDidUpdate(prevProps) {
    if (get(prevProps, 'chat.id') !== get(this.props, 'chat.id')) {
      this.setState({
        ...metaLoading,
        messages: []
      })

      this._load()
    }
  }

  _load = () => {
    this.setState((prevState) => ({
      meta: {
        ...prevState.meta,
        isLoading: true,
      },
    }), () => {
      this.getMessages()
    })
  }

  render() {
    return (
      <Loading
        isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'messages.length', 0) == 0}
      >
        <dl className='Messages__body'>
          {this.state.messages.length > 0 && this.state.messages.map((message) => (
            <div className='Messages__item' key={message.id}>
              <time>{moment(message.createdAt).format('YYYY-MM-DD HH:mm')}</time>

              <UserWithImage user={message.user}/>

              <div className='Messages__item__content'>
                {(()=> {
                  switch (message.messageType) {
                    case 'text':
                      return message.text
                    case 'image':
                    case 'eternal_image':
                      return (
                        <div
                          className='Messages__item__content__image'
                        >
                          <p
                            className='Messages__item__content__image__p'
                          >
                            Sent an image
                          </p>

                          <ImageLoader
                            klassName='ImageLoader--fixed-height'
                            renderAsImg
                            url={get(message, 'attachment.url')}
                          />
                        </div>
                      )
                    case 'video':
                      return (
                        <div
                          className='Messages__item__content__image'
                        >
                          <p
                            className='Messages__item__content__image__p'
                          >
                            Sent a video
                          </p>

                          <PostsListItemVideo
                            video={{
                              videoUrl: get(message, 'videoUrl'),
                              thumbnailUrl: get(message, 'videoThumbnailUrl'),
                              height: 115,
                              width: 200
                            }}
                          />
                        </div>
                      )
                    default:
                      return get(this.props.messageTypes, message.messageType)
                  }
                })()}
              </div>
            </div>
          ))}

          <LoadMore
            klassName='Messages__item'
            onLoadMore={this._load}
            meta={this.state.meta}
          />
        </dl>
      </Loading>
    );
  }
}

export default MessageList
